import { gql, useMutation } from "@apollo/client";

const START_COURSE_ENROLLMENT = gql`
  mutation StartCourseEnrollment(
    $userId: String!
    $courseId: String!
    $crmWebhookUrl: String
  ) {
    startCourseEnrollment(
      userId: $userId
      courseId: $courseId
      crmWebhookUrl: $crmWebhookUrl
    ) {
      success
      message
      courseUrl
    }
  }
`;

export const useStartCourseEnrollment = () => {
  const [startCourseEnrollmentMutation, { loading, error, data }] = useMutation(
    START_COURSE_ENROLLMENT
  );

  return {
    startCourseEnrollmentMutation,
    loading,
    error,
    data,
  };
};